module.exports = __webpack_public_path__ + "img/co_wrapbg8.ec6d208a.png";